import { PdApiActions, PdApiActionsEnum } from "../actions/pdApiActions";
import { pdApiInitialState } from "./initialState";
import * as _ from "lodash";

const pdApiReducer = (
  state: State.PdApi = pdApiInitialState,
  action: PdApiActions
): State.PdApi | undefined => {
  switch (action.type) {
    case PdApiActionsEnum.SET_DOMAIN_GROUPS: {
      const domainGroupList = action.payload;
      const domainGroups = _.keyBy(domainGroupList as Api.DomainGroup[], "id");
      return { ...state, domainGroups };
    }
    case PdApiActionsEnum.SET_DOMAINS: {
      const domainList = action.payload;
      const domains = _.keyBy(domainList as Api.Domain[], "id");
      return { ...state, domains };
    }
    case PdApiActionsEnum.SET_FEATURES: {
      const featureList = action.payload;
      const features = _.keyBy(featureList as Api.Feature[], "id");
      return { ...state, features };
    }
    case PdApiActionsEnum.SET_PARAMETER_CATEGORIES: {
      const parameterCategoryList = action.payload;
      const parameterCategories = _.keyBy(parameterCategoryList as Api.ParameterCategory[], "id");
      return { ...state, parameterCategories };
    }
    case PdApiActionsEnum.SET_FAULTS: {
      const faults = action.payload;
      return { ...state, faults };
    }
    case PdApiActionsEnum.SET_ESCALATOR_FAULTS: {
      const escalatorFaults = action.payload;
      return { ...state, escalatorFaults };
    }
    case PdApiActionsEnum.SET_DOOR_FAULTS: {
      const doorFaults = action.payload;
      return { ...state, doorFaults };
    }
    case PdApiActionsEnum.SET_NON_KONE_FAULTS: {
      const nonKoneFaults = action.payload;
      return { ...state, nonKoneFaults };
    }

    case PdApiActionsEnum.SET_LIFT_PARAMETERS: {
      const liftParameters = action.payload;
      return { ...state, liftParameters };
    }
    case PdApiActionsEnum.SET_DRIVE_PARAMETERS: {
      const driveParameters = action.payload;
      return { ...state, driveParameters };
    }
    case PdApiActionsEnum.SET_GROUP_PARAMETERS: {
      const groupParameters = action.payload;
      return { ...state, groupParameters };
    }
    case PdApiActionsEnum.SET_SAFETY_PARAMETERS: {
      const safetyParameters = action.payload as Api.SafetyParameter[];
      return { ...state, safetyParameters };
    }
    case PdApiActionsEnum.SET_ESCALATOR_PARAMETERS: {
      const escalatorParameters = action.payload as Api.EscalatorParameter[];
      return { ...state, escalatorParameters };
    }
    case PdApiActionsEnum.SET_DOOR_PARAMETERS: {
      const doorParameters = action.payload as Api.DoorParameter[];
      return { ...state, doorParameters };
    }
    case PdApiActionsEnum.SET_APM_PARAMETERS: {
      const apmParameters = action.payload as Api.ApmParamters[];
      return { ...state, apmParameters };
    }
    case PdApiActionsEnum.SET_APM_FAULTS: {
      const apmFaults = action.payload as Api.APMFault[];
      return { ...state, apmFaults };
    }
    case PdApiActionsEnum.SET_SIGNALIZATION_FAULTS: {
      const signalizationFaults = action.payload as Api.SignalizationFault[];
      return { ...state, signalizationFaults };
    }
    case PdApiActionsEnum.SET_DRIVE_FAULTS: {
      const driveFaults = action.payload as Api.DriveFault[];
      return { ...state, driveFaults };
    }
    case PdApiActionsEnum.SET_LIFT_FAULTS: {
      const liftFaults = action.payload as Api.LiftFault[];
      return { ...state, liftFaults };
    }
    case PdApiActionsEnum.SET_GROUP_FAULTS: {
      const groupFaults = action.payload as Api.GroupFault[];
      return { ...state, groupFaults };
    }
    case PdApiActionsEnum.SET_NETWORK_FAULTS: {
      const networkFaults = action.payload as Api.NetworkFault[];
      return { ...state, networkFaults };
    }
    case PdApiActionsEnum.SET_MONITORING_FAULTS: {
      const monitoringFaults = action.payload as Api.MonitoringFault[];
      return { ...state, monitoringFaults };
    }
    case PdApiActionsEnum.SET_FAULT_CATEGORIES: {
      const faultCategoryList = action.payload;
      const faultCategories = _.keyBy(faultCategoryList as Api.FaultCategory[], "id");
      return { ...state, faultCategories };
    }
    case PdApiActionsEnum.SET_MONITORING_FAULT_CATEGORIES: {
      const monitoringFaultCategories = action.payload;
      return { ...state, monitoringFaultCategories };
    }
    case PdApiActionsEnum.SET_FAULT_PRIORITIES: {
      const faultPriorityList = action.payload;
      const faultPriorities = _.keyBy(faultPriorityList as Api.FaultPriority[], "id");
      return { ...state, faultPriorities };
    }
    case PdApiActionsEnum.SET_ROLES: {
      const roles = action.payload;
      return { ...state, roles };
    }
    case PdApiActionsEnum.SET_USER_GROUPS: {
      const userGroups = action.payload;
      return { ...state, userGroups };
    }
    case PdApiActionsEnum.SET_USERS: {
      const users = action.payload;
      return { ...state, users };
    }
    case PdApiActionsEnum.SET_ENUMERATION_GROUPS: {
      const enumerationGroups = action.payload;
      return { ...state, enumerationGroups };
    }
    case PdApiActionsEnum.SET_FAULT_COMPONENTS: {
      const faultComponents = action.payload;
      return { ...state, faultComponents };
    }
    case PdApiActionsEnum.SET_KCE_VERSIONS: {
      const kceVersionList = action.payload;
      const kceVersions = _.keyBy(kceVersionList as Api.KceVersion[], "id");
      return { ...state, kceVersions };
    }
    case PdApiActionsEnum.SET_KCE_PRODUCTS: {
      const kceProductsList = action.payload;
      const kceProducts = _.keyBy(kceProductsList as Api.KceProduct[], "id");
      return { ...state, kceProducts };
    }
    case PdApiActionsEnum.SET_DRIVE_VERSIONS: {
      const driveVersionList = action.payload;
      const driveVersions = _.keyBy(driveVersionList as Api.DriveVersion[], "id");
      return { ...state, driveVersions };
    }
    case PdApiActionsEnum.SET_DRIVE_SIGNALS: {
      const signals = action.payload;
      return { ...state, signals };
    }
    case PdApiActionsEnum.SET_DRIVE_TESTS: {
      const driveTests = action.payload;
      return { ...state, driveTests };
    }
    case PdApiActionsEnum.SET_DRIVE_SIGNAL_GROUPS: {
      const signalGroups = action.payload;
      return { ...state, signalGroups };
    }
    case PdApiActionsEnum.SET_ESCALATOR_RTDS: {
      const escalatorRTDs = action.payload;
      return { ...state, escalatorRTDs };
    }
    case PdApiActionsEnum.SET_ESCALATOR_RTD_GROUPS: {
      const escalatorRTDGroups = action.payload;
      return { ...state, escalatorRTDGroups };
    }
    case PdApiActionsEnum.SET_ESCALATOR_EVENT_LOGS: {
      const escalatorEventLogs = action.payload;
      return { ...state, escalatorEventLogs };
    }
    case PdApiActionsEnum.SET_EVENT_CLASSES: {
      const eventClasses = action.payload;
      return { ...state, eventClasses };
    }
    case PdApiActionsEnum.SET_EVENT_PIDS: {
      const eventPids = action.payload;
      return { ...state, eventPids };
    }
    case PdApiActionsEnum.SET_EVENT_TYPES: {
      const eventTypes = action.payload;
      return { ...state, eventTypes };
    }
    case PdApiActionsEnum.SET_EXT_COMMANDS: {
      const extCommands = action.payload;
      return { ...state, extCommands };
    }
    case PdApiActionsEnum.SET_MESSAGE_TYPES: {
      const messageTypes = action.payload;
      return { ...state, messageTypes };
    }
    case PdApiActionsEnum.SET_IO_BOARD_TYPES: {
      const ioBoardTypes = action.payload;
      return { ...state, ioBoardTypes };
    }
    case PdApiActionsEnum.SET_IO_CPUS: {
      const ioCpuEnums = action.payload;
      return { ...state, ioCpuEnums };
    }
    case PdApiActionsEnum.SET_IO_NETWORKS: {
      const ioNetworks = action.payload;
      return { ...state, ioNetworks };
    }
    case PdApiActionsEnum.SET_IO_OPTIONS: {
      const ioOptions = action.payload;
      return { ...state, ioOptions };
    }
    case PdApiActionsEnum.SET_IO_ENUMTYPE: {
      const ioOptionsEnumType = action.payload;
      return { ...state, ioOptionsEnumType };
    }
    case PdApiActionsEnum.SET_IO_DATATYPES: {
      const ioDataTypes = action.payload;
      return { ...state, ioDataTypes };
    }
    case PdApiActionsEnum.SET_IO_BASIC_DATATYPES: {
      const ioBasicDataTypes = action.payload;
      return { ...state, ioBasicDataTypes };
    }
    case PdApiActionsEnum.SET_IO_DATA_SECTIONS: {
      const iodataSections = action.payload;
      return { ...state, iodataSections };
    }
    case PdApiActionsEnum.SET_COMMONENUMERATIONS: {
      const enumerations = action.payload;
      return { ...state, enumerations };
    }
    case PdApiActionsEnum.SET_COMMONENUMERATIONITEMS: {
      const enumerationItems = action.payload;
      return { ...state, enumerationItems };
    }
    case PdApiActionsEnum.SET_DECKS: {
      const decks = action.payload;
      return { ...state, decks };
    }
    case PdApiActionsEnum.SET_SIDES: {
      const sides = action.payload;
      return { ...state, sides };
    }
    case PdApiActionsEnum.SET_ELECTRIFICATIONS: {
      const electrifications = action.payload;
      return { ...state, electrifications };
    }
    case PdApiActionsEnum.SET_AAD_GROUPS: {
      const aadgroups = action.payload;
      return { ...state, aadgroups };
    }
    case PdApiActionsEnum.SET_LOCALES: {
      const locales = action.payload;
      return { ...state, locales };
    }
    case PdApiActionsEnum.SET_TRANSLATION_LOG_ITEMS: {
      const translationLogItems = action.payload;
      return { ...state, translationLogItems };
    }
    case PdApiActionsEnum.SET_TRANSLATION_SUMMARY: {
      const translationSummary: Api.SeriesDataset[] = action.payload;
      return { ...state, chartData: { ...state.chartData, translationSummary } };
    }
    case PdApiActionsEnum.SET_LANGUAGE_COVERAGE: {
      const languageCoverage: Api.SeriesDataset[] = action.payload;
      return { ...state, chartData: { ...state.chartData, languageCoverage } };
    }
    case PdApiActionsEnum.SET_ITEMTYPE_LANGUAGE_COVERAGE: {
      const itemTypeLanguageCoverage: Api.ItemTypeSeriesDataset[] = action.payload;
      return { ...state, chartData: { ...state.chartData, itemTypeLanguageCoverage } };
    }
    case PdApiActionsEnum.SET_DOOR_EVENT_CLASSES: {
      const doorEventClasses = action.payload;
      return { ...state, doorEventClasses };
    }
    case PdApiActionsEnum.SET_DOOR_EVENT_TYPES: {
      const doorEventTypes = action.payload;
      return { ...state, doorEventTypes };
    }
    case PdApiActionsEnum.SET_DOOR_EVENT_PIDS: {
      const doorEventPids = action.payload;
      return { ...state, doorEventPids };
    }
    case PdApiActionsEnum.SET_DOOR_EXT_COMMANDS: {
      const doorExtCommands = action.payload;
      return { ...state, doorExtCommands };
    }
    case PdApiActionsEnum.SET_ESCALATOR_EVENT_CLASSES: {
      const EscalatorEventClasses = action.payload;
      return { ...state, EscalatorEventClasses };
    }
    case PdApiActionsEnum.SET_ESCALATOR_EVENT_TYPES: {
      const EscalatorEventTypes = action.payload;
      return { ...state, EscalatorEventTypes };
    }
    case PdApiActionsEnum.SET_ESCALATOR_EVENT_PIDS: {
      const EscalatorEventPids = action.payload;
      return { ...state, EscalatorEventPids };
    }
    case PdApiActionsEnum.SET_ESCALATOR_EXT_COMMAND: {
      const EscalatorExtCommands = action.payload;
      return { ...state, EscalatorExtCommands };
    }
    case PdApiActionsEnum.SET_ESCALATOR_REQUEST_TYPES: {
      const EscalatorRequestTypes = action.payload;
      return { ...state, EscalatorRequestTypes };
    }
    case PdApiActionsEnum.SET_DOOR_VERSIONS: {
      const DoorVersions = action.payload;
      DoorVersions.sort((a, b) => Number(b.versionId) - Number(a.versionId));
      return { ...state, DoorVersions };
    }
    case PdApiActionsEnum.SET_ESCALATOR_VERSIONS: {
      const escalatorVersionList = action.payload;
      const EscalatorVersions = _.keyBy(escalatorVersionList as Api.EscalatorVersion[], "id");
      return { ...state, EscalatorVersions };
    }
    case PdApiActionsEnum.SET_DATAACT_CODES: {
      const dataActCodes = action.payload;
      return { ...state, dataActCodes };
    }
    case PdApiActionsEnum.SET_ESCALATOR_DATAACT_CODES: {
      const escalatorDataActCodes = action.payload;
      return { ...state, escalatorDataActCodes };
    }
    case PdApiActionsEnum.SET_GRAND_NORMS: {
      const grandNorms = action.payload;
      return { ...state, grandNorms };
    }
    default:
      return state;
  }
};

export default pdApiReducer;
